import { Component } from '@angular/core';
import { ColumnTypesEnum } from '@r1-development/rps-shared-ui';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-boolean-cell',
    templateUrl: './boolean-cell.component.html',
    standalone: false
})
export class BooleanCellComponent implements ICellRendererAngularComp {
  value: any;
  notAvailable = ColumnTypesEnum.NotAvailable;

  agInit(params: ICellRendererParams<any, any>): void {
    this.value = params.value;
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }
}
